module.exports = __webpack_public_path__ + "static/media/facebook .90af1082.jpg";